import { faGrid } from "@fortawesome/pro-regular-svg-icons";
import { MprcCardTypography } from "components/MprcCardTypography";
import { MprcRibbonGenericCard } from "components/MprcRibbonList";
import { useTranslation } from "react-i18next";

interface IProps {
    onClick?: () => void;
}

export const GeneralCardLoadMore = (props: IProps) => {
    const { t } = useTranslation("core");
    return <MprcRibbonGenericCard
        height="100%"
        icon={faGrid}
        marginWidth={0}
        message={<MprcCardTypography variant="linkAlt">{t("Card.ShowMoreText")}</MprcCardTypography>}
        {...props}
    />;
};
